<template>
  <div>
    <!--全局组件 -->
    <AppBanner :list='list' :domain="domain"/>
  </div>
</template>

<script>
import {ref} from 'vue'
import {getCarousel} from '@/api'


export default {
  setup(props) {
    const list = ref([]);
    const domain = ref(process.env.VUE_APP_DOMAIN)
    getCarousel().then(res => {
      if (res.total > 0) {
        list.value=res.rows;
      }

      // if(res.msg='操作成功'){
      //     list.value=res.result;
      // }
    }).catch(err => {
      console.log(err);
    })


    return {list,domain}
  }
};
</script>

<style lang="less" scoped>
</style>